// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"expandablesections_wrapper__3YBfn","subWrapper":"expandablesections_subWrapper__GRbSP"};